/** =========================================================
 * Login controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.login')
    .controller('LoginController', LoginController);

  LoginController.$inject = ['$rootScope', '$api', '$state'];

  function LoginController($rootScope, $api, $state) {
    var vm = this;

    activate();

    // //////////////

    function activate() {
      // bind here all data from the form
      vm.account = {};
      // place the message if something goes wrong
      vm.authMsg = '';
      vm.loading = false;

      vm.login = function () {
        try {
          if (vm.loginForm.$valid) {
            vm.authMsg = '';
            vm.loading = true;

            $api.login({
              email: vm.account.email,
              password: vm.account.password
            }).then(function (response) {
              // assumes if ok, response is an object with some data, if not, a string with error
              // customize according to your api
              if (response.status) {
                $api.initSocket();

                $rootScope.getAppConfig().then(function (appConfig) {
                  $state.go(appConfig.mainPage);
                });
              } else {
                $rootScope.$applyAsync(function () {
                  vm.loading = false;

                  switch (response.error) {
                    case 'invalid_email':
                      vm.authMsg = 'Invalid email';
                      break;
                    case 'invalid_password':
                      vm.authMsg = 'Invalid password';
                      break;
                    case 'user_not_active':
                      vm.authMsg = 'User not active';
                      break;
                    default:
                      vm.authMsg = 'Unknown error';
                    }
                });
              }
            }, function () {
              $rootScope.$applyAsync(function () {
                vm.loading = false;
                vm.authMsg = 'Server Request Error';
              });
            });
          } else {
            // set as dirty if the user click directly to login so we show the validation messages
            /* jshint -W106*/
            vm.loginForm.account_email.$dirty = true;
            vm.loginForm.account_password.$dirty = true;
          }
        } catch (error) {
          Raven.captureException(error);
        }
      };
    }
  }
})();
